import {Table} from 'antd';
import {BankTransactionType} from "../../api/Constants";
import {toFSDateTime} from "../../util/timeutils";

export const PaymentTable = ({payments, type="payment", props}) => {
    const accountColumns = [
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            render: (val) => {
                return `$ ${val}`
            }
        },
        {
            title: 'Account',
            dataIndex: 'accountName',
            key: 'Account'
        },
        {
            title: 'Confirmed By',
            dataIndex: 'username',
            key: 'username',
            // sorter: (a, b) => a.username.toLowerCase().localeCompare(b.username.toLowerCase()),
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            render: (val, record, index) => {
                return BankTransactionType.Label[val]
            },
        },
        {
            title: 'Timestamp',
            dataIndex: 'timestamp',
            key: 'timestamp',
            render: (val) => toFSDateTime(new Date(val)),
            sorter: (a, b) => (new Date(a.timestamp))- (new Date(b.timestamp)),
        },
        {
            title: 'Notes',
            dataIndex: 'notes',
            key: 'notes',
        }
    ];

    if (type === 'expense') {
        accountColumns.push({
            title: 'Department',
            dataIndex: 'department',
            key: 'department',
        });
        accountColumns.push({
            title: 'Category',
            dataIndex: 'category',
            key: 'category',
        })
    }

    const tablePagination = {
        defaultPageSize: 30,
        pageSizeOptions: [30, 60, 90, 120]
    }

    return <Table columns={accountColumns} dataSource={payments} pagination={tablePagination} />
}